<!-- 
TELA PARA INCLUSÃO/ALTERAÇÃO DAS NOTAS REFERNCIADAS
-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';
import nfFormOrigem from './nf-form-origem'

export default {
    props: {
        nfref: {type: Array}, 
        nf: { type: Object },
        title: { type: Boolean, default: true},
    },

    components: {
        nfFormOrigem
    },

    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            selectedNf: [],
            showNfOrigem: false,        //exibe o form de selecao de notas de origem
            operacaonfOrigem: ''
        }
    },

    computed: {
    },

    methods: {
        handleAddRef () {
            //ADICIONA NOVA NF REFERENCIADA            
            var ref = {...this.$store.getters.getEntities.nfref}
            ref.nfreftp = 1
            ref.modnfref ='01'
            ref.modnfpref ='04'
            ref.modecfref ='2B'
            ref.validation = {}
            this.nfref.push(ref)
        },

        handleDeleteRef (index) {
            //EXCLUI NF REFERENCIADA
            // console.log(index)
            this.nfref.splice(index,1)
            // console.log(this.nfref.length)
        },

        closeOrigemForm (selectedNf) {
            //FECHAMENTO DA TELA DE NF DE ORIGEM
            this.showNfOrigem = false
            if (!selectedNf) {
                return
            }
            if (!selectedNf.length) {
                return
            }
            //selectedNf = NOTAS SELECIONADAS NA TELA DE NOTAS DE ORIGEM
            //ADICIONA AS NOTAS SELECIONADAS NO OBJETO nfref
            for (var x = 0; x < selectedNf.length; x++) {
                if (this.nfref.findIndex(obj => obj.chave == selectedNf[x].chave) < 0) {
                    let ref = {...this.$store.getters.getEntities.nfref}
                    ref.nfreftp = 1
                    ref.chave = selectedNf[x].chave
                    ref.codnfref = selectedNf[x].codnf
                    ref.serie = selectedNf[x].serie
                    ref.nf = selectedNf[x].nf
                    ref.validation = {}
                    this.nfref.push(ref)
                }
            }

        },

        handleNfOrigem () {            
            //exibe o formulario de selecao de notas origem
            // console.log(this.codpart)
            // return
            if (this.nf.codpart == null) {
                this.$erpToastError('Informe o participante')
                return
            }
            if (this.tpnf === 'I' && this.codnatesret == null) {  //NOTA DE INDUSTRIALIZACAO OBRIGA NAT DE RETORNO
                this.$erpToastError('Informe a natureza de retorno')
                return
            }

            //PARA NOTAS DE SAIDA: EXIBE NOTAS DE ENTRADA PARA SELECAO
            //PARA NOTAS DE ENTRADA: EXIBE NOTAS DE SAIDA PARA SELECAO
            //PARA NOTAS DE COMPLEMENTO DE IMPOSTO SAIDA: EXIBE NOTAS DE SAIDA PARA SELECAO
            if (this.nf.operacaonf === 'S' && (this.nf.tpnf === 'P' || this.nf.tpnf === 'CR' || this.nf.tpnf === 'DB')) {
                this.operacaonfOrigem = 'S' 
            } else
            if (this.nf.operacaonf === 'E' && (this.nf.tpnf === 'P' || this.nf.tpnf === 'CR' || this.nf.tpnf === 'DB')) {
                this.operacaonfOrigem = 'E' 
            } else
            if (this.nf.operacaonf === 'S') {
                this.operacaonfOrigem = 'E'
            } else {
                this.operacaonfOrigem = 'S'
            }
            
            this.showNfOrigem = true                     
        },

    },

    watch: {
    },

    created () {
        // if (this.nfref.length == 0) {
        //     this.handleAddRef()
        // }        
    }

}

</script>

<template>
    <div>
        <label-title v-if="title" title="Documentos Fiscais Referenciados"></label-title><br>
        <alert v-if="nfref.length == 0" type="warning" text="É necessário informar um documento fiscal referenciado para a natureza selecionada"></alert>
        <div class="col" v-for="(nfref, index) in nfref" :key="index">
            <div class="row align-items-center">
                <div class="col-md-2 col-6">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.nfreftp"></v-label>
                        <div class="input-group">
                        <div class="input-group-prepend">
                            <select class="form-control form-control-sm" v-model="nfref.nfreftp">
                                <option v-for="opt in metadata.nfref.nfreftp.options" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
                            </select>
                        </div>
                        </div>
                    </div>
                </div>
                <!-- NFREFTP: 1=NF-E, 2=CT-E -->
                <form-field v-model="nfref.chave" type="text" col="6" :metadata="metadata.nfref.chave" 
                    name="chave" :v-errors="errors" v-validate="metadata.nfref.chave.validator"></form-field>

                <!-- <div class="col-md-4 col-6" v-show="nfref.nfreftp == '1' || nfref.nfreftp == '2'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.chave"></v-label>
                        <input type="text" class="form-control form-control-sm" v-model="nfref.chave" maxlength="44">
                        <small class="error" v-if="nfref.validation.chave">{{ nfref.validation.chave }}</small>
                    </div>
                </div> -->

                <!-- NFREFTP = 3 => nf modelo 1/1A -->
                <!-- NFREFTP = 4 => nf de produtor -->
                <div class="col-md-2 col-6" v-if="nfref.nfreftp == '4'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.modnfpref"></v-label>
                        <select class="form-control form-control-sm" v-model="nfref.modnfpref">
                            <option v-for="opt in metadata.nfref.modnfpref.options" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-1 col-6" v-if="nfref.nfreftp == '3' || nfref.nfreftp == '4'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.serie"></v-label>
                        <input type="text" class="form-control form-control-sm" v-model="nfref.serie" maxlength="3">
                        <small class="error" v-if="nfref.validation.serie">{{ nfref.validation.serie }}</small>
                    </div>
                </div>
                <div class="col-md-2 col-6" v-if="nfref.nfreftp == '3' || nfref.nfreftp == '4'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.nf"></v-label>
                        <input-value class="form-control form-control-sm" v-model="nfref.nf" :precision="0" maxlength="9"></input-value>
                        <small class="error" v-if="nfref.validation.nf">{{ nfref.validation.nf }}</small>
                    </div>
                </div>
                <div class="col-md-2 col-6" v-if="nfref.nfreftp == '3' || nfref.nfreftp == '4'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.cnpj"></v-label>
                        <input-value class="form-control form-control-sm" v-model="nfref.cnpj" :precision="0" maxlength="14"></input-value>
                        <small class="error" v-if="nfref.validation.cnpj">{{ nfref.validation.cnpj }}</small>
                    </div>
                </div>
                <div class="col-md-2 col-6" v-if="nfref.nfreftp == '4'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.cpf"></v-label>
                        <input-value class="form-control form-control-sm" v-model="nfref.cpf" :precision="0" maxlength="11"></input-value>
                    </div>
                </div>
                <div class="col-md-2 col-6" v-if="nfref.nfreftp == '4'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.iest"></v-label>
                        <input-value class="form-control form-control-sm" v-model="nfref.iest" :precision="0" maxlength="15"></input-value>
                    </div>
                </div>
                <div class="col-md-2 col-6" v-if="nfref.nfreftp == '5'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.modecfref"></v-label>
                        <select class="form-control form-control-sm" v-model="nfref.modecfref">
                            <option v-for="opt in metadata.nfref.modecfref.options" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2 col-6" v-if="nfref.nfreftp == '5'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.necf"></v-label>
                        <input-value class="form-control form-control-sm" v-model="nfref.necf" :precision="0" maxlength="3"></input-value>
                    </div>
                </div>
                <div class="col-md-2 col-6" v-if="nfref.nfreftp == '5'">
                    <div class="form-group">
                        <v-label :metadata-field="metadata.nfref.ncoo"></v-label>
                        <input-value class="form-control form-control-sm" v-model="nfref.ncoo" :precision="0" maxlength="6"></input-value>
                    </div>
                </div>
                <div class="col-md-1 col-1">
                    <v-button label="" title="" icon="fa-trash" @click="handleDeleteRef(index)"></v-button>
                </div>
            </div>
        </div>
        <br>
        <div class="row col">
            <v-button label="Adicionar Documento Referenciado" title="Adicione documentos fiscais referenciados" :nb-btdef="true" @click="handleAddRef"></v-button>
            <v-button label="Pesquisar Notas de Origem" title="Selecione as notas de origem" :nb-btdef="true" @click="handleNfOrigem"></v-button>
            <!-- <v-button label="Continuar" title="" :nb-btdef="true" class="float-right" @click="handleIncluir"></v-button> -->
        </div>
        <br>
        <!-- SELECAO DE NOTAS DE ORIGEM - USUARIO SELECIONA NF DE ORIGEM -->
        <nf-form-origem v-if="showNfOrigem" :codpart="nf.codpart" :operacaonf="operacaonfOrigem" :nforigem="selectedNf" @closeform="closeOrigemForm"></nf-form-origem>

    </div>

</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/nf-form-ref.vue